
































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Chart from './Chart.vue';
import ProcessNumberBase from '@/components/myDashboard/ProcessNumberBase.vue';

@Component({
  components: {
    Chart,
    ProcessNumberBase,
  },
})
export default class MyDashboardBase extends Vue {
  private openpen = false;
  private focus = '';
  private type = 'month';
  private typeToLabel = {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    '4day': '4 Days',
  };
  private selectedEvent = {};
  private selectedElement = null;
  private selectedOpen = false;
  private events = [];
  private colors = [
    'blue',
    'indigo',
    'deep-purple',
    'cyan',
    'green',
    'orange',
    'grey darken-1',
  ];
  private names = [
    'Meeting',
    'Holiday',
    'PTO',
    'Travel',
    'Event',
    'Birthday',
    'Conference',
    'Party',
  ];
}
